import { render, staticRenderFns } from "./config_page.vue?vue&type=template&id=2d138d00&scoped=true"
import script from "./config_page.vue?vue&type=script&lang=js"
export * from "./config_page.vue?vue&type=script&lang=js"
import style0 from "./config_page.vue?vue&type=style&index=0&id=2d138d00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d138d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d138d00')) {
      api.createRecord('2d138d00', component.options)
    } else {
      api.reload('2d138d00', component.options)
    }
    module.hot.accept("./config_page.vue?vue&type=template&id=2d138d00&scoped=true", function () {
      api.rerender('2d138d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/config_page.vue"
export default component.exports